import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const initialize = createAction(`${actionKey}/INITIALIZE`, (payload)=>payload);
export const updateCommentsOrder = createAction(`${actionKey}/UPDATE_COMMENT_ORDER`, (order)=>({
        order
    }));
export const updateCommentsOrderDone = createAction(`${actionKey}/UPDATE_COMMENT_ORDER_DONE`, (order)=>({
        order
    }));
export const toggleTheme = createAction(`${actionKey}/TOGGLE_THEME`, ()=>({}));
export const toggleThemeDone = createAction(`${actionKey}/TOGGLE_THEME_DONE`, ()=>({}));
export const setTheme = createAction(`${actionKey}/SET_THEME`, (theme)=>({
        theme
    }));
export const setThemeSkin = createAction(`${actionKey}SET_THEME_SKIN`, (themeSkin)=>({
        themeSkin
    }));
export const updatePointsCount = createAction(`${actionKey}/UPDATE_POINTS_COUNT`, (pointsCount)=>({
        pointsCount
    }));
export const toggleMature = createAction(`${actionKey}/TOGGLE_MATURE`, (current)=>({
        current
    }));
export const updateContentFilter = createAction(`${actionKey}.UPDATE_CONTENT_FILTER`, (contentFilter)=>({
        contentFilter
    }));
export const switchVersion = createAction(`${actionKey}/SWITCH_VERSION`, (toggleState)=>toggleState);
export const resendVerificationEmail = createAction(`${actionKey}/RESEND_VERIFICATION_EMAIL`, ()=>({}));
export const resendVerificationEmailSuccess = createAction(`${actionKey}/RESEND_VERIFICATION_EMAIL/SUCCESS`, ()=>({}));
export const resendVerificationEmailFail = createAction(`${actionKey}/RESEND_VERIFICATION_EMAIL/FAIL`, ()=>({}));
export const updateEmail = createAction(`${actionKey}/UPDATE_EMAIL`, (email)=>({
        email
    }));
export const updateEmailSuccess = createAction(`${actionKey}/UPDATE_EMAIL/SUCCESS`, (email)=>({
        email
    }));
export const updateEmailFail = createAction(`${actionKey}/UPDATE_EMAIL/FAIL`, (email)=>({
        email
    }));
export const setViewMode = createAction(`${actionKey}.SET_VIEW_MODE`, (viewMode)=>viewMode);
export const setIsMobile = createAction(`${actionKey}/SET_MOBILE`, (isMobile)=>({
        isMobile
    }));
export const fetchFeedbackCount = createAction(`${actionKey}/FETCH_FEEDBACK_COUNT`, ()=>({}));
export const setFeedbackCount = createAction(`${actionKey}/SET_FEEDBACK_COUNT`, (count)=>count);
// Chat Settings
export const setChatSettingOnline = createAction(`${actionKey}.CHAT_SETTING_ONLINE`, (value)=>({
        value
    }));
export const setChatSettingMuted = createAction(`${actionKey}.CHAT_SETTING_MUTED`, (value)=>({
        value
    }));
export const setChatSettingSoundsMuted = createAction(`${actionKey}.CHAT_SETTING_SOUNDS_MUTED`, (value)=>({
        value
    }));
